import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import microsoft from '../../../assets/images/microsoft-icon.svg';
import { getItemFromStorage, removeItemFromStorage, saveItemInStorage } from "../../../helper/storage";
import { getDemo, setDemoModeOn } from "../../../redux/actions/demo";
import { acceptInvite, getManagerInvite } from "../../../redux/actions/invites";
import { createLoginWitMicrosoftRequest, login } from "../../../redux/actions/login";
import PopUpCompany from "../../global/PopUpCompany/PopUpCompany";
import Button from "../../global/form/Button/Button";
import Input from "../../global/form/Input/Input";
import "./Login.scss";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [keepLogged, setKeepLogged] = useState(true);
  const [error, setError] = useState(false);
  const [popUp, setPopUp] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showEmailForm, setShowEmailForm] = useState(false);
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const inviteInfo = useSelector(state => state.invites);
  const inviteId = location.search.split("code=")[1];
  const verificationMicrosoft = location.hash.includes("code")
  const [stopVerification, setStopVerification] = useState(false);
  const invitationID = getItemFromStorage("INVITE_ID")
  const [loadingInfos, setLoadingInfos] = useState(false);

  const handleMicrosoft = () => {
    const handleLogin = () => {
      const currentUrl = window.location.href;

      const url = new URL(currentUrl);
      const redirectUri = `${url.protocol}//${url.host}/login`;

      const loginUrl = `https://login.microsoftonline.com/common/oauth2/v2.0/authorize?client_id=4e243692-2927-48cc-af80-73458c25b6df&scope=user.read%20openid%20profile%20offline_access&redirect_uri=${encodeURIComponent(redirectUri)}&response_mode=fragment&response_type=code`;

      saveItemInStorage("INVITE_ID", inviteId);
      window.open(loginUrl, "_self");
    };

    handleLogin();
  };
  const handleLogin = (e) => {
    e.preventDefault();
    const payload = {
      email: email,
      password: password
    }
    if (email === "e2w@gestor.com.br" && password === "e2w@gestor") {
      dispatch(setDemoModeOn())
      dispatch(getDemo()).then(() => history.push("/selecionar-empresa"));
    } else {
      setIsLoading(true);
      dispatch(login(payload, keepLogged))
        .then(() => {
          if (inviteId && inviteInfo?.data?.company) {
            dispatch(acceptInvite(inviteId, {
              accept: true
            })).then(() => {
              setIsLoading(false);
              setPopUp(true);
            });
          } else {
            setIsLoading(false);
            history.push("/selecionar-empresa");
          }
        })
        .catch(() => {
          setError(true);
          setIsLoading(false);
          setPassword("");
          setTimeout(() => {
            setError(false);
          }, 3000)
        });
    }
  }

  const handlePopUpClose = () => {
    setPopUp(false);
    history.push("/selecionar-empresa");
  }

  useEffect(() => {
    const handleMicrosoftLogin = async () => {
      setIsLoading(true);
      setStopVerification(true)
      const hashValue = location.hash.substr(6)?.split('&session_state=')[0];
      if (hashValue) {
        const microsoftData = {
          code: decodeURIComponent(hashValue),
          redirectUri: (() => {
            const currentUrl = window.location.href;
            const url = new URL(currentUrl);
            const redirectPath = "/login";
            return `${url.protocol}//${url.host}${redirectPath}`;
          })()
        };
        dispatch(createLoginWitMicrosoftRequest(microsoftData)).then(() => {
          if (invitationID) {
            setLoadingInfos(true)
            let managerInvite = dispatch(getManagerInvite(invitationID))
            let inviteAccept = dispatch(acceptInvite(invitationID, {
              accept: true
            }))
            Promise.all([managerInvite, inviteAccept])
              .then((data) => {
                setLoadingInfos(false);
                if (data[0] && Object.keys(data[0]).length > 0) {
                  removeItemFromStorage("INVITE_ID");
                  setPopUp(true);
                }
                else {
                  history.push("/selecionar-empresa");
                }
              })
          } else {
            setIsLoading(false);
            history.push("/selecionar-empresa");
          }
          setIsLoading(false);
        })
      }
    };

    if (!stopVerification && verificationMicrosoft) {
      handleMicrosoftLogin();
    }

  }, [verificationMicrosoft]);

  useEffect(() => {
    if (inviteId) {
      setLoadingInfos(true)
      dispatch(getManagerInvite(inviteId))
        .then(() => {
          setLoadingInfos(false)
        })
    }
  }, [inviteId])

  return (
    <section className="Login">
      <h1 hidden>E2W <span>ADMIN</span></h1>
      <article>
        <h2>Olá,</h2>
        <p>Acesse sua conta para continuar.</p>
      </article>
      {inviteId && (
        <div className="welcome-text">
          {inviteInfo.isFetching && <h3>Carregando...</h3>}
          {!inviteInfo.isFetching && !inviteInfo.data.company && <h3>Você já aceitou esse convite! Faça seu login abaixo:</h3>}
          {inviteInfo.data.company && <>
            <img src={inviteInfo.data.company && inviteInfo.data.company.icon} />
            <div>
              <h3>Olá.</h3>
              <h3>Realize seu login </h3>
              <h3>para se tornar</h3>
              <h3>um administrador</h3>
              <h3>da {inviteInfo.data.company && inviteInfo.data.company.name}</h3>
            </div>
          </>}
        </div>
      )}
      <form onSubmit={handleLogin}>
        <div className="buttons">
          <div onClick={e => handleMicrosoft(e)} role="button" className="microsoft-button">
            <img src={microsoft} alt="microsoft" />
            <p className="text-microsoft">Entrar com microsoft</p>
          </div>

          <button
            type="button"
            className="email-toggle"
            onClick={() => setShowEmailForm(v => !v)}
          >
            <span>Entrar com e-mail e senha</span>
            <span className={`email-toggle__chevron ${showEmailForm ? "open" : ""}`} />
          </button>
        </div>

        <div className={`email-form ${showEmailForm ? "expanded" : ""}`}>
          <div className="email-form__inner">
            <p className={`feedback ${error ? "visible" : null}`}>
              Usuário ou senha incorretos
            </p>
            <Input
              updateState={setEmail}
              type="email"
              displayError={false}
              displayErrorMessage=""
              label="E-mail"
              value={email} />
            <Input
              updateState={setPassword}
              type="password"
              displayError={false}
              displayErrorMessage=""
              label="Senha"
              value={password} />
            <div className="actions">
              <div />
              <button
                type={"button"}
                className="forgot-password"
                onClick={() => history.push("/recuperar-senha")}
              >
                esqueci minha senha
              </button>
            </div>
            <Button className="button-submit" type={"submit"} onClick={(e) => handleLogin(e)} disabled={isLoading}>
              {isLoading ? 'Entrando...' : <> ENTRAR <span className="fa6-solid--arrow-right" /> </>}
            </Button>
          </div>
        </div>
      </form>
      <PopUpCompany
        company={inviteInfo.data.company && inviteInfo.data.company.name}
        active={popUp}
        companyImage={inviteInfo?.data?.company?.icon}
        closeCompany={() => {
          handlePopUpClose()
        }} />
    </section>
  );
}

export default Login;
